/*eslint-disable*/
// helpers
import { areObjectsEqual } from "../../utils/general"

const addGroupNameToOperations = (group, groupDTO) => {
    const groupNameOperation = {
        "op": "replace",
        "path": "displayName",
        "value": group.groupName,
      };
      groupDTO.operations.push(groupNameOperation);
};

const addDescriptionToOperations = (group, groupDTO) => {
    const descriptionOperation = {
        "op": "replace",
        "path": "description",
        "value": group.description,
      };
      groupDTO.operations.push(descriptionOperation);
};

export const makeEditGroupDTO = (group) => {
    const groupDTO = {
        schemas: "urn:ietf:params:scim:api:messages:2.0:PatchOp",
        operations: [],
      };
    addGroupNameToOperations(group, groupDTO);
    addDescriptionToOperations(group, groupDTO);
    return groupDTO;
  };

export const getInitialGroup = (group = {}) => {
    const groupName = group.displayName;
    const [application, role] = groupName?.split('-') || [];
    const description = group.description;
    return {
        groupName,
        description,
        application: application?.trim(),
    };
};

export const areFormValuesChanged = (groupObj={}, group={}) => {
  const initialGroup = getInitialGroup(groupObj);
  if(areObjectsEqual(initialGroup, group)) {
    return false
  }
  return true
}